export default __webpack_public_path__ + "static/logo-723c4df377ffc977eddbcea79b240300.svg";